import PropTypes from "prop-types"
import { get, map, first } from "lodash"
import ItemCell from "./item-cell"
import { TitleRowBox, GroupColumn } from "../styled"

export default function TitleRow({ columns, data, items, cellWidth, getBackgroundColor }) {
  return (
    <TitleRowBox className="title-row">
      {map(columns, ({ color, noData, isUnmodeled }, i) => {
        const loading = !data[i] && !noData && !isUnmodeled
        const item = first(get(items, i)) ?? {}
        return (
          <GroupColumn key={`title-col${i}`} className="group-column">
            <ItemCell
              loading={loading}
              item={item}
              width={cellWidth}
              color={color}
              chartBarFallbackWidth="80%"
              style={getBackgroundColor(loading, color)}
            />
          </GroupColumn>
        )
      })}
    </TitleRowBox>
  )
}

TitleRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
  })).isRequired,
  items: PropTypes.array.isRequired,
  data: PropTypes.array,
  cellWidth: PropTypes.number.isRequired,
  getBackgroundColor: PropTypes.func.isRequired,
}
